import { Helmet } from 'react-helmet-async';
import { useEnvVariable } from '../contexts/EnvironmentContext';

const AdobeLaunchHelmet = () => {
  const { viteAdobeLaunchEnvironment } = useEnvVariable();
  return (
    <Helmet>
      <script src={viteAdobeLaunchEnvironment} async></script>
    </Helmet>
  );
};

export default AdobeLaunchHelmet;
